import { IVincularTiposDocumentoPorEtapa } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoDocumentoPorEtapa/TipoDocumentoPorEtapa";
import {
    DesvincularDocumentoPorEtapaService,
    EditarDocumentoPorEtapaService,
    ListarTiposDeDocumentoService,
    ListarTiposDocumentoEtapaCategoriaAtendimentoPorCategoriaService,
    ListartiposdocumentoetapatipocasoecategoriaatendimentoService,
    ListEtapasPorCategoriaAtendimentoETipoCasoService,
    VincularDocumentoPorEtapaService,
} from "../../../../Services/Geral/GestaoDeCadastros/TipoDocumentoPorEtapa/TipoDocumentoPorEtapaService";
import { Controller } from "../../../Controller";

export async function ListarTiposDocumentoEtapaCategoriaAtendimentoPorCategoriaController(
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number,
    FL_DINAMICO: boolean,
    ID_ETAPA_TIPO_CASO: number
) {
    return Controller(
        ListarTiposDocumentoEtapaCategoriaAtendimentoPorCategoriaService(
            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
            FL_DINAMICO,
            ID_ETAPA_TIPO_CASO
        )
    );
}
export async function VincularDocumentoPorEtapaController(
    requestBody: IVincularTiposDocumentoPorEtapa
) {
    return Controller(VincularDocumentoPorEtapaService(requestBody));
}
export async function ListarTiposDeDocumentoController() {
    return Controller(ListarTiposDeDocumentoService());
}
export async function EditarDocumentoPorEtapaController() {
    return Controller(EditarDocumentoPorEtapaService());
}

export async function DesvincularDocumentoPorEtapaController(
    idTipoDocumentoEtapaTipoCaso: number
) {
    return Controller(
        DesvincularDocumentoPorEtapaService(idTipoDocumentoEtapaTipoCaso)
    );
}

export function ListEtapasPorCategoriaAtendimentoETipoCasoController(
    ID_CATEGORIA_ATENDIMENTO: number,
    ID_TIPO_CASO: number
) {
    return Controller(
        ListEtapasPorCategoriaAtendimentoETipoCasoService(
            ID_CATEGORIA_ATENDIMENTO,
            ID_TIPO_CASO
        )
    );
}
export function ListartiposdocumentoetapatipocasoecategoriaatendimentoController() {
    return Controller(
        ListartiposdocumentoetapatipocasoecategoriaatendimentoService()
    );
}
